


















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Direction, directionToDegree, DirectionDetectionPhase } from '@/services/facetracker';

type StepStatus = 'complete' | 'current' | 'next';

interface StepData {
  index: DirectionDetectionPhase;
  direction: Direction;
  rotation: number;
  status: StepStatus;
}

@Component({})
export default class StepProgress extends Vue {
  @Prop({ default: [Direction.Left, Direction.Up] })
  directions!: Direction[];

  @Prop({ default: DirectionDetectionPhase.None })
  step!: DirectionDetectionPhase;

  get top(): number {
    const defaultValue: number = 25;
    if (!this.$store.getters['camera/isPC']) return defaultValue;
    const circleSize: number = 40;
    const circleMargin: number = 40;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    const faceOvalHeight: number = this.$store.getters['camera/faceOvalHeight'];
    const overOval: number = (displayHeight - faceOvalHeight) / 2 - (circleSize + circleMargin);
    return Math.max(defaultValue, overOval);
  }

  get steps(): StepData[] {
    const step = this.step;
    return this.directions
      .map((direction, index) => {
        return {
          index,
          direction,
          rotation: directionToDegree(direction),
          status: this.getStepStatus(index, step)
        };
      })
      .filter(d => d.direction !== Direction.Center);
  }

  get lines(): StepData[] {
    const step = this.step;
    const result = this.directions
      .map((direction, index) => {
        return {
          index,
          direction,
          rotation: 0,
          status: this.getStepStatus(index, step)
        };
      })
      .filter(d => d.direction === Direction.Center);
    return result;
  }

  private getStepStatus(index: number, step: DirectionDetectionPhase): StepStatus {
    if (step > index) {
      return 'complete';
    } else if (step === index) {
      return 'current';
    }
    return 'next';
  }
}
